export default __webpack_public_path__ + "static/media/behavior_icon.ba2ef912.png";